<template>
  <div>
    <Button
      type="primary"
      v-hasPermission="[
        'configurationManagement:monitorMailboxConfiguration:create'
      ]"
      @click="modal1 = true"
    >
      {{ $t("configuration_management.mailbox_management.addEmail") }}
    </Button>
    <Modal
      v-model="modal1"
      :title="$t('configuration_management.mailbox_management.addEmail')"
      @on-ok="mailboxsSubmit('mailboxsForm')"
      @on-cancel="mailboxsReset('mailboxsForm')"
      :loading="loading"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="mailboxsForm"
        :model="mailboxsForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 邮箱名称 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.emailName')"
          prop="name"
        >
          <Input
            v-model="mailboxsForm.name"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 主机地址 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.host')"
          prop="host"
        >
          <Input
            v-model="mailboxsForm.host"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 端口 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.port')"
          prop="port"
        >
          <Input
            type="number"
            v-model="mailboxsForm.port"
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 用户名 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.userName')"
          prop="userName"
        >
          <Input v-model="mailboxsForm.userName" style="width:300px;"></Input>
        </FormItem>

        <!-- 密码 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.password')"
          prop="password"
        >
          <Input
            type="password"
            v-model="mailboxsForm.password"
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 描述 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.describe')"
          prop="describe"
        >
          <Input
            v-model="mailboxsForm.describe"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import TableMailboxs from "./TableMailboxs.vue";

var tableMailboxs = TableMailboxs;
export default {
  name: "AddMailboxs",
  data() {
    return {
      mailboxsForm: {
        name: "",
        host: "",
        port: "",
        userName: "",
        password: "",
        describe: ""
      },
      modal1: false,
      loading: true,
      ruleValidate: {
        name: [
          { required: true, message: this.$t("configuration_management.mailbox_management.emailNameRequired"), trigger: "change" }
        ],
        port: [{ required: true, message: this.$t("configuration_management.mailbox_management.portRequired") }],
        host: [
          { required: true, message: this.$t("configuration_management.mailbox_management.hostRequired"), trigger: "change" }
        ],
        userName: [
          { required: true, message: this.$t("configuration_management.mailbox_management.userNameRequired"), trigger: "change" }
        ],
        password: [
          { required: true, message: this.$t("configuration_management.mailbox_management.passwordRequired"), trigger: "change" }
        ],
        describe: [
          { required: false, message: this.$t("configuration_management.mailbox_management.pleaseEnterDescribe"), trigger: "change" },
          {
            type: "string",
            max: 100,
            message: this.$t("configuration_management.common.max100Characters"),
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    mailboxsSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 创建日程
          this.$api.mailbox
            .create({
              name: this.mailboxsForm.name,
              host: this.mailboxsForm.host,
              port: this.mailboxsForm.port,
              userName: this.mailboxsForm.userName,
              password: this.mailboxsForm.password,
              description: this.mailboxsForm.describe
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableMailboxs.methods.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.modal1 = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    mailboxsReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/AddMailboxs.vue